import { render, staticRenderFns } from "./OperatorAnswer.vue?vue&type=template&id=ef96465c&scoped=true"
import script from "./OperatorAnswer.vue?vue&type=script&lang=js"
export * from "./OperatorAnswer.vue?vue&type=script&lang=js"
import style0 from "./OperatorAnswer.vue?vue&type=style&index=0&id=ef96465c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef96465c",
  null
  
)

export default component.exports